__turbopack_context__.v({
  "arrowContainer": "CreateWalletHeader-module__SZnH2G__arrowContainer",
  "arrowIcon": "CreateWalletHeader-module__SZnH2G__arrowIcon",
  "nextButton": "CreateWalletHeader-module__SZnH2G__nextButton",
  "nextButtonDisabled": "CreateWalletHeader-module__SZnH2G__nextButtonDisabled",
  "root": "CreateWalletHeader-module__SZnH2G__root",
  "step": "CreateWalletHeader-module__SZnH2G__step",
  "stepCompleted": "CreateWalletHeader-module__SZnH2G__stepCompleted",
  "stepContainer": "CreateWalletHeader-module__SZnH2G__stepContainer",
});
